/**
 * Core: Get Search
 * ------------------------------------------------------------------------------
 * - Queries the Storefront API and returns a formatted search object.
 */
import searchProducts from '~/graphql/search.gql'

import { formatSearch } from '~/format/search'

/**
 * Return a formatted Shopify search object.
 * - Query products from Storefront API using search terms
 * - Format each product response object
 * - https://shopify.dev/docs/api/storefront/latest/queries/search
 * @param {data} data - Parameters.
 * @param {String} [startCursor] - Start point in search listing. Loads the 1st
 *   page if `null`. See: https://shopify.dev/docs/api/usage/pagination-graphql
 * @param {String} [terms] - Search terms.
 * @param {String?Number} first - How many products to load.
 * @returns
 */
export async function getSearch({ startCursor = null, terms = '', first = 4 }) {
  try {
    const storefrontResponse = await mint.Query({
      query: searchProducts,
      variables: {
        country: mint.shop.country,
        query: terms,
        first,
        language: mint.shop.language,
        after: startCursor,
      },
    })

    return formatSearch(storefrontResponse)
  } catch (error) {
    mint.Log('warning', 'Could not fetch Search', error, {
      terms,
    })

    return error
  }
}